import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTable } from 'simple-datatables';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { PiiGridService } from 'src/app/_services/pii-grid.service';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import { ApiHttpService } from 'src/app/_services/api-http.service';
import { StorageService } from 'src/app/_services/storage.service';
import { moreThanOneWhiteSpaceValidator } from 'src/app/common/common.validators';
import { environment } from 'src/environments/environment';
import { MerchantService } from '../../../merchants/merchant-master/merchant.service';
import { CustomerService } from '../../customer-service';
import Swal from 'sweetalert2';
import { Route, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { TitleCasePipe } from '@angular/common';
const {API_URL} = environment;

@Component({
  selector: 'app-customer-blocked',
  templateUrl: './customer-blocked.component.html',
  styleUrls: ['./customer-blocked.component.scss']
})
export class CustomerBlockedComponent implements OnInit {
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  merchantstatusform: FormGroup;
  isForm1Submitted: boolean;
  @Input() merchantStatusConfig: any;
  @Input() onMerchantMId: EventEmitter<any> = new EventEmitter<any>();
  data: any;
  Resdata: any;
  customerId: any
  walletStatus : any;
  registeredMobile : any
  loading: boolean =false;
  remarkData: any=[];
  dataTable: DataTable;
  segmentData: any;
  auditData : any[];
  private gridApi!: GridApi;
  showLimitedStatus: boolean = false;

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  public columnDefs: ColDef[] = [
    { field: 'walletStatus', headerName: 'Status',lockVisible:true, resizable: true, cellRenderer: 'agGroupCellRenderer' },
    { field: 'remark',  headerName: 'Remark',lockVisible:true, },
    { field: 'updatedBy',  headerName: 'Updated By', lockVisible:true,},
    { field: 'updatedOn',  headerName: 'Updated On' ,lockVisible:true,},
    { colId: 'unmasking', field: 'unmasking', headerName: 'Unmasking', lockVisible: true, width: 120, cellRenderer: BtnCellRenderer1, cellRendererParams: [
      {
        clicked: async (event: any, param: any) => {
          this.piiGridService.unmaskRow(param.data, this.gridApi);
        },
        buttonIconClass: 'icon-frame-1',
        buttonText: '',
        buttonVisible: true,
        customImage: 'assets/images/unmask-icon.png'
      }
    ] },
  ]

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];

  constructor(private services: ApiHttpService, private alertService: AlertService, private formbuilder: FormBuilder,private storage:StorageService,private merchantService: MerchantService,private customerService : CustomerService,private router : Router,
    private readonly menuService: MenusService, private readonly piiGridService: PiiGridService) {

    this.data = this.merchantStatusConfig
    this.merchantstatusform = formbuilder.group({
      Status: ["",[ Validators.required]],
      // Segment: ["",[ Validators.required]],
      Remark: ["", [Validators.required,moreThanOneWhiteSpaceValidator(),Validators.maxLength(200)]],
    })
    // if (this.merchantstatusform) {
    //   this.merchantstatusform.get('Segment')?.valueChanges.subscribe(value => {
    //     console.log('Selected Segment:', value); // Log selected value to console
    //   });
    // }

  }

  get form1() {
    return this.merchantstatusform.controls;
  }

  ngOnInit(): void {
    console.log("Blocked Component");
    this.auditData = [];
    this.merchantStatusDropdown();
    this.merchantSegmentDropdown();
    this.checkPermissionForLimitedStatus();

    // permission visibility for unmasking column similar to customer-master
    try {
      const path = '';
      const permissions = this.menuService.getPermissions(path);
      const unmaskCol = this.columnDefs.find(c => c['colId'] === 'unmasking');
      if (unmaskCol) unmaskCol.hide = !(permissions && permissions !== '');
      this.columnDefsCopy = [...(this.columnDefs.filter((col) => !col?.hide))];
      this.tableSelectedColumn = [...(this.columnDefs.filter((col) => !col?.hide))];
    } catch (err) {
      console.error('Error applying permissions for blocked modal unmask column', err);
    }

    this.onMerchantMId.subscribe((res) => (
      console.log(JSON.stringify(res)),
      this.walletStatus = res.walletStatus,
      this.customerId = res.mobile,
      this.fetchRemarkList(),
      this.auditDataList(),
      //alert(res),
      this.merchantstatusform.controls['Status'].setValue(''),
      this.loading = false,
      this.reset(),
      this.isForm1Submitted = false,
      this.walletStatus === 'CLOSED' ? this.merchantstatusform.disable() : this.merchantstatusform.enable()
      ))

  }

  checkPermissionForLimitedStatus(){
      const menus = this.storage.getMenuItems();
      const raw = menus?.rawMenus || [];

      const custList = raw.find((m:any)=> m?.MenuLink === '/customerMaster');

      const permissionAction = (custList?.PermissionAction || custList?.permissionAction || '').toString();
      this.showLimitedStatus = permissionAction.split(',').map((a:any)=> a.trim().toUpperCase()).includes('SEARCH');

      if(this.showLimitedStatus){
        const current = this.merchantstatusform.get('Status')?.value;
        if(current && !['ACTIVE','BLOCKED'].includes(current)){
          this.merchantstatusform.get('Status')?.setValue('');
        }
      }
  }

  onGridReady(params: GridReadyEvent<any>) {
    console.log("AG Grid")
    this.gridApi = params.api;
  }

  auditDataList(){
    console.log("Customer Id : "+JSON.stringify(this.customerId));
    this.customerService.getCustomerStatusAudit(this.customerId).subscribe((res:any)=>{
      console.log(res.response.data);
      this.auditData = res.response.data;
    })
  }

  CustomerWalletStatusChange(formvalue : any){
   console.log("Customer Id :"+this.customerId);
   console.log("Status :"+formvalue.Status);
   console.log("Comment :"+formvalue.Remark);
   if (this.walletStatus === 'CLOSED') {
     this.alertService.errorAlertWithMessage("This customer is permanently closed, status cannot be changed");
     return;
   }
   if(this.walletStatus == formvalue.Status){
    let tempStatus = this.walletStatus || TitleCasePipe
    this.alertService.errorAlertWithMessage("Status is already "+tempStatus);
    return;
   }
   if (formvalue.Status === 'CLOSED') {
     Swal.fire({
       title: 'Are you sure?',
       text: 'Closing this customer is permanent and cannot be undone or reverted back.',
       icon: 'warning',
       showCancelButton: true,
       confirmButtonText: 'Yes, close it',
       cancelButtonText: 'Cancel'
     }).then((result) => {
       if (result.isConfirmed) {
         this.submitCustomerWalletStatusChange(formvalue);
       }
     });
     return;
   }
   this.submitCustomerWalletStatusChange(formvalue);
  }

  private submitCustomerWalletStatusChange(formvalue: any) {
   if (this.merchantstatusform.valid) {
      console.log("Valid");
      let walletStatusChangeRequest = {
          "userId" : this.customerId,
          "status" : formvalue.Status,
          "remark" : formvalue.Remark
        }
      this.customerService.updateCustomerWalletStatusChange(walletStatusChangeRequest)
        .subscribe((data:any) => {
          console.log("Response"+JSON.stringify(data.response.message));
          if(data.response.status == 200){
            this.closeModal.emit({
              showModal: false
            })
            Swal.fire('Customer wallet status updated successfully','','success')
            this.router.navigate(['/customerMaster']);
            return;
          }else{
            this.closeModal.emit({
              showModal: false
            })
            Swal.fire(data.response.message,'','error')
            this.router.navigate(['/customerMaster']);
            return;
          }
        })
        // Swal.fire('Error while changing the wallet status','','error')
    }else{
      this.alertService.errorAlertWithMessage("Mandatory Fields are missing");
        console.log("Not Valid");
    }

  }

  CustomerStatus(formvalue: any) {
    debugger
    if (this.merchantstatusform.valid) {
      let data1 = {
        "Mid": this.customerId,
        "Status": formvalue.Status,
        "Remark": formvalue.Remark,
        // "Segment": formvalue.Segment,
        "Approvel_type": "",
        "Added_By": this.storage.getUserName().toString()
      }

      this.loading = true
      document?.getElementById('loading')?.classList.add("spinner-border")
      document?.getElementById('loading')?.classList.add("spinner-border-sm")
      this.services.post(`${API_URL}/checkAllStatus`,data1).subscribe((res) => (
        this.reset(),
          res.text=="SUCCESS" ?
      this.services
        .post(
          `${API_URL}/ChangeMerchantStatus`, data1
        )
        .subscribe((data) => {

           if(formvalue.Status=="Send to Negative"&&data.length <= 0){
            this.alertService.successAlert(
              "Status successfully updated"
            )
            this.reset();
            this.isForm1Submitted = false;
            this.closeModal.emit({
              showModal: false
            })
          }
          if (data.length > 0) {
            if (data[0].status != "false") {
              this.alertService.successAlert(
                "Status successfully updated"
              )
              this.reset();
              this.isForm1Submitted = false;
              this.closeModal.emit({
                showModal: false
              })
            }

            else {
              this.alertService.errorAlert({
                html: `Can not change the status, ${data[0].Message}`
              }).then(() => {
                this.reset();
                this.isForm1Submitted = false;
                this.closeModal.emit({
                  showModal: false
                });
              })

            }
          }
          this.loading = false
          document?.getElementById('loading')?.classList.remove("spinner-border")
          document?.getElementById('loading')?.classList.remove("spinner-border-sm")
        }): this.alertService.errorAlert({
          html: `Can not change the status, ${res[0].Message}`
        }).then(() => {
          this.reset();
          this.isForm1Submitted = false;
          this.closeModal.emit({
            showModal: false
          });
        }),
        this.closeModal.emit({
          showModal: false
        })
    ));
    }
    this.isForm1Submitted = true;
  }

  // MerchantStatus(formvalue: any) {
  //   debugger
  //   if (this.merchantstatusform.valid) {
  //     let data = {
  //       "Mid": this.merchantId,
  //       "Status": formvalue.Status,
  //       "Remark": formvalue.Remark,
  //       "Approvel_type": "",
  //       "Added_By": this.storage.getUserName().toString()
  //     }
  //     this.loading = true
  //     document?.getElementById('loading')?.classList.add("spinner-border")
  //     document?.getElementById('loading')?.classList.add("spinner-border-sm")
  //     this.services
  //       .post(
  //         `${API_URL}/ChangeMerchantStatus`, data
  //       )
  //       .subscribe((data) => {

  //          if(formvalue.Status=="Send to Negative"&&data.length <= 0){
  //           this.alertService.successAlert(
  //             "Status successfully updated"
  //           )
  //           this.reset();
  //           this.isForm1Submitted = false;
  //           this.closeModal.emit({
  //             showModal: false
  //           })
  //         }
  //         if (data.length > 0) {
  //           if (data[0].status != "false") {
  //             this.alertService.successAlert(
  //               "Status successfully updated"
  //             )
  //             this.reset();
  //             this.isForm1Submitted = false;
  //             this.closeModal.emit({
  //               showModal: false
  //             })
  //           }

  //           else {
  //             this.alertService.errorAlert({
  //               html: `Can not change the status, ${data[0].Message}`
  //             }).then(() => {
  //               this.reset();
  //               this.isForm1Submitted = false;
  //               this.closeModal.emit({
  //                 showModal: false
  //               });
  //             })

  //           }
  //         }
  //         this.loading = false
  //         document?.getElementById('loading')?.classList.remove("spinner-border")
  //         document?.getElementById('loading')?.classList.remove("spinner-border-sm")
  //       });

  //   }
  //   this.isForm1Submitted = true;
  // }


  merchantStatusDropdown() {
//alert("Resdata")
    let postdata = {
      "Type": "8",
      "Value": "merchant_status"
    }

    return this.services
      .post(
        `${API_URL}/GetDropdown`, postdata
      )
      .subscribe((res) => (this.Resdata = res));
  }


  merchantSegmentDropdown() {
    // return this.services.get(`${API_URL}/getAllSegment`).subscribe((res) => {
    //   this.segmentData = JSON.parse(res.data);
    // });
  }


  reset() {
    this.merchantstatusform.reset(); // Reset form data
    this.merchantstatusform.markAsUntouched(); // Reset form data
    this.merchantstatusform.updateValueAndValidity(); // Reset form data
  }

  fetchRemarkList(){
   // alert(this.merchantId)
  //   this.merchantService.fetchRemarkList(this.merchantId).subscribe((data)=>{
  // // alert(data[0]?.addedBy)
  // console.log("list======"+JSON.stringify(data));
  // this.remarkData = data
  // this.dataTable ? this.dataTable.destroy() : console.log(this.remarkData)
  // this.remarkData ? this.dataTable = new DataTable("#dataTableExample") : this.dataTable.destroy()
  // if (this.remarkData) {
  //   this.remarkData.forEach((element: any) => {
  //     this.dataTable.rows().add(Object.values(element));
  //   })
  // }
  //               }

  //     )
  }

}
